import styled from 'styled-components'
import Input from 'src/stories/Input'

export const StyledTabsSearchInput = styled(Input)(({ theme }) => ({
  borderRadius: theme.constants.borderRadius,
}))
